import type { GetThesisReplyEligibilityRow } from '@morfi/backend-sdk-v2/client';

export type ThesisReplyWriteStatus =
  | 'disabled'
  | 'signed-out'
  | 'checking'
  | 'error'
  | 'eligible'
  | 'ineligible';

export interface ThesisReplyWriteAccess {
  status: ThesisReplyWriteStatus;
  eligibility: GetThesisReplyEligibilityRow | undefined;
  dataUpdatedAt: number;
  refresh: () => void;
}

export const READ_ONLY_THESIS_REPLY_WRITE_ACCESS: ThesisReplyWriteAccess = {
  status: 'disabled',
  eligibility: undefined,
  dataUpdatedAt: 0,
  refresh: (): void => undefined,
};
